// import "../styles/OrganisationChart.css";

// export default function OrganizationChart() {
//   return (
//     <section className="org-section">

//       <div className="container">

//         {/* Header */}
//         <div className="org-header">

//           <span className="org-badge">OUR TEAM STRUCTURE</span>

//           <h2>Organization Overview</h2>

//           <p>
//             A well-structured team ensuring precision, quality, and efficiency
//             across all manufacturing operations.
//           </p>

//         </div>

//         {/* Cards */}
//         <div className="org-grid">

//           <div className="org-card">Design Department <span>8</span></div>
//           <div className="org-card">Quality Department <span>7</span></div>
//           <div className="org-card">Planning Department <span>4</span></div>
//           <div className="org-card">Store Department <span>10</span></div>
//           <div className="org-card">Production Line <span>12</span></div>
//           <div className="org-card">Paint Line <span>4</span></div>
//           <div className="org-card">Maintenance Dept <span>3</span></div>
//           <div className="org-card">Turret Department <span>4</span></div>

//           <div className="org-card highlight">
//             Skilled Operators (Production Stage) <span>12</span>
//           </div>

//         </div>

//         {/* Experience Section */}
//         <div className="org-experience">

//           <h3>Industry Experience</h3>

//           <p>
//             We have a highly experienced team with over
//             <b> 20+ years of expertise</b> in Air Conditioning and Refrigeration.
//           </p>

//           <p>
//             Our workforce includes professionals from
//             <b> Videocon</b> and other reputed industrial organizations.
//           </p>

//         </div>

//       </div>

//     </section>
//   );
// }



















import "../styles/OrganisationChart.css";

export default function OrganizationChart() {
  return (
    <section className="org-section">

      <div className="container">

        {/* Header */}
        <div className="org-header">

          <span className="org-badge">OUR TEAM STRUCTURE</span>

          <h2>Organization Overview</h2>

          <p>
            A well-structured team ensuring precision, quality, and efficiency
            across all manufacturing operations.
          </p>

        </div>

        {/* Cards */}
        <div className="org-grid">

          <div className="org-card">
            <h4>Design Department</h4>
            <span>8</span>
          </div>

          <div className="org-card">
            <h4>Quality Department</h4>
            <span>7</span>
          </div>

          <div className="org-card">
            <h4>Planning Department</h4>
            <span>4</span>
          </div>

          <div className="org-card">
            <h4>Store Department</h4>
            <span>10</span>
          </div>

          <div className="org-card">
            <h4>Production Line</h4>
            <span>12</span>
          </div>

          <div className="org-card">
            <h4>Paint Line</h4>
            <span>4</span>
          </div>

          <div className="org-card">
            <h4>Maintenance Dept</h4>
            <span>3</span>
          </div>

          <div className="org-card">
            <h4>Turret Department</h4>
            <span>4</span>
          </div>

          <div className="org-card highlight1">
            <h4>Skilled Operators (Production Stage)</h4>
            <span>12</span>
          </div>

        </div>

        {/* Experience Section */}
        <div className="org-experience">

          <h3>Industry Experience</h3>

          <p>
            We have a highly experienced team with over
            <b> 20+ years of expertise</b> in Air Conditioning and Refrigeration.
          </p>

          <p>
            Our workforce includes professionals from
            <b> Videocon</b> and other reputed industrial organizations.
          </p>

        </div>

      </div>

    </section>
  );
}